import { Option } from './option';

export class InvalidQuote {
    public QuoteId: number;
    public ValidQuote: boolean;
    public PlantId: number;
    public PlantNumber: number;
    public PlantDesc: string;
    public ProductLineId: number;
    public ProductLineDesc: string;
    public ModelId: number;
    public ModelNumber: string;
    public ModelDesc: string;
    public Options: Option[];

    constructor() {
        this.Options = new Array<Option>();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/invalid-quote.ts